// Default messages - can be expanded later
const messages: Record<string, { translation: Record<string, string> }> = {
  en: {
    translation: {
      welcome: "Welcome",
      login: "Login",
      logout: "Logout",
      dashboard: "Dashboard",
      inventory: "Inventory",
    }
    }
};

export default messages; 